<template functional>
  <span
    v-if="![0, 1, false, true].includes(props.row[props.column])"
    style="color: red"
    >{{ props.row[props.column] }}</span
  >
  <i
    v-else
    :class="{
      'el-icon-check':
        [1, true].includes(props.row[props.column]) ||
        props.row[props.column] === true,
      'el-icon-close':
        [0, false].includes(props.row[props.column]) ||
        props.row[props.column] === false
    }"
    :style="{
      color: [1, true].includes(props.row[props.column]) ? 'green' : 'red'
    }"
  >
  </i>
</template>

<script>
export default {
  name: "MaintenanceRenderCheck"
};
</script>

<style></style>
